import { computed } from "vue";
import { useInspectionStore } from "@/stores/inspection";

export default function useDeckData() {
  const inspectionStore = useInspectionStore();

  let structure = computed(() => inspectionStore.selectedInspection);

  const getData = computed({
    get() {
      const filterUserRWays = structure.value?.userRWays?.find((obj) => obj?.onUnder == "1");

      if (filterUserRWays == undefined) {
        return null;
      }

      const filteredRoadWay = structure.value?.structureRoadways.find(
        (obj) =>
          obj?.onUnder == "1" && obj?.brkey == filterUserRWays.brkey && obj?.featureKey == filterUserRWays.featureKey
      );

      return filteredRoadWay?.roadWidth ?? null;
    },
  });

  return {
    getData,
  };
};
